/**
 * Reports Service
 * Handles fetching report data
 */

import { httpClient } from '../lib/httpClient';
import type { 
  ReportsResponse, 
  ReportsQueryParams,
  ReportsExportQueryParams,
  ReportsExportResponse
} from '../interfaces/apiInterfaces/reports';

/**
 * Fetch questions report with filters
 * @param params - Query parameters for filtering, pagination
 * @returns Report data with pagination info
 */
export async function fetchQuestionsReport(params?: ReportsQueryParams): Promise<ReportsResponse> {
  try {
    const response = await httpClient.get<ReportsResponse>(
      '/v1/reports/questions',
      { params }
    );
    return response.data;
  } catch (error) {
    console.error('Error fetching questions report:', error);
    throw error;
  }
}

/**
 * Export questions report to CSV
 * @param params - Query parameters for filtering (without pagination)
 * @returns Export response with presigned download URL
 */
export async function exportQuestionsReport(params?: ReportsExportQueryParams): Promise<ReportsExportResponse> {
  try {
    const response = await httpClient.post<ReportsExportResponse>(
      '/v1/reports/questions/export/email',
       {}, 
      { params }
    );
    return response.data;
  } catch (error) {
    console.error('Error exporting questions report:', error);
    throw error;
  }
}
